const tradingSections = {
    main: { key: 'main', name: 'Main Options', },
    extra: { key: 'extra', name: 'Extra Options', },


}

const tradingPages = {



    tequipments: {
        key: 'tequipments',
        title: 'Trading Listing Summary',
        description: 'Trading List',
        fetchUrl: 'getAllTEquipments',
        fetchOne: 'getOneTEquipments',

        addUrl: 'postTEquipments',
        editUrl: 'postTEquipments',
        removeUrl: 'removeTEquipments',
        pageType: 'form',
        parent: 'main',
        // populate: ["category", 'brand'],
        options: { noAddNew: true },
        addNew: -1,
        extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },

        tabs: [
            { title: 'Pending', filter: { "status": '0' } },
        ],

        // page: 'tequipments',

        image: '/images/covers/2.jpg',
        headers: [

            { key: 'tequipmentId', type: 'TextInput', information: { label: 'Equipment Id', }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },

            { type: 'TextInput', key: 'title', information: { label: 'Title', }, showMain: true, inExport: true },
            { type: 'EditorInput', key: 'body', information: { label: 'Body', }, showMain: false, fullCol: true },

            { key: 'image', type: 'ImageInput', information: { label: 'Image', single: false, cropper: true, }, showMain: true, fullCol: true },
            // { key: 'creator.company', type: 'TextInput', col: '6', information: { label: 'Company', }, showMain: true, settings: { disabled: true }, fullCol: true, hideInList: true, inExport: true },

            { key: 'owner', type: 'SelectInput', col: '6', information: { label: 'Owner', type: 'api', fields: { value: '_id', title: 'values.company' }, address: 'getUsers', filter: {}, linkInfo: { ref: "users", loader: "isPostingData", } }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false },
            // { key: 'brand', type: 'SelectInput', col: '6', information: { label: 'Brand', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'brands' } }, showMain: false, inExport: true },
            // { key: 'values.model', type: 'TextInput', col: '6', information: { label: 'Model', }, showMain: true, inExport: true },
            // { key: 'values.serialNumber', type: 'TextInput', col: '6', information: { label: 'Serial Number', }, showMain: true, inExport: true },


            { key: 'category', type: 'MultiLevelInput', col: '6', information: { label: 'Category', type: 'api', startPoint: null, root: '', reference: 'values.parent', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tcategories' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },
            { key: 'place', type: 'MultiLevelInput', col: '6', information: { label: 'place', type: 'api', startPoint: null, root: '', reference: 'values.parent', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: true, fullCol: true, inExport: true },

            // { key: 'place', type: 'MultiSelectInput', col: '6', information: { label: 'Place', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: true }, showMain: false, fullCol: true },

            // { key: 'values.year', type: 'NumberInput', col: '6', information: { label: 'Year of manufacturing', }, showMain: false, fullCol: true, inExport: true },
            // { key: 'values.price.daily', type: 'PriceInput', col: '6', information: { label: 'Daily Price', }, showMain: true, inExport: true },
            // { key: 'values.price.weekly', type: 'PriceInput', col: '6', information: { label: 'Weekly Price', }, showMain: true, inExport: true },
            // { key: 'values.price.monthly', type: 'PriceInput', col: '6', information: { label: 'Monthly Price', }, showMain: true, inExport: true },
            { key: 'price', type: 'PriceInput', col: '6', information: { label: 'Price', }, showMain: true, inExport: true },


            ///// dependencies
            {
                type: 'AttributesLoader',
                key: 'attributes',
                ref: 'category',
                information: { label: 'Attributes', inputClass: 'transparent-input', refKey: 'values.categories', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tattributes' } },
                showMain: false,
                fullCol: true,
                col: '12',
                dependencies: [{
                    refKey: 'category',
                    targetKey: 'attributes',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '1' }, operator: { value: '==' }, target: { value: "1" } }
                            }
                        },
                    },
                    show: true,
                    init: true,

                    changeHeader: { key: 'information.refValue', value: '@data.category', },

                }],

            },

            // { key: 'values.wiki', type: 'SelectInput', col: '6', information: { label: 'Wiki', type: 'api', fields: { value: 'values.slug', title: 'values.model' }, address: 'getAll', filter: { page: 'wiki', sort: { 'values.model': 1 } } }, showMain: false },

            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'Active', value: '1' }, { title: "Rejected", value: '-1' }, ] }, settings: { required: true }, showMain: true, inExport: true },
            { key: 'condition', type: 'SelectInput', col: '6', information: { label: 'Condition', type: 'local', default: '0', items: [{ title: "Used", value: 'Used' }, { title: 'New', value: 'New' }] }, settings: { required: true }, showMain: true, inExport: true },

            //// Invert
            // { key: 'values.unavailable', type: 'SwitchInput', col: '6', information: { label: 'Available', invert: true, required: false }, showMain: true, inExport: true },

            { key: 'sold', type: 'SwitchInput', col: '6', information: { label: 'Sold', }, showMain: false, },

            { key: 'remark', type: 'TextAreaInput', col: '12', information: { label: 'Remark', }, showMain: false, },

            // { type: 'DateInput', key: 'values.certExpDate', col: '6', information: { label: 'CERT Expire Date', }, showMain: false, },
            // { col: '6', key: 'values.certFile', type: 'FileInput', information: { label: 'LE CERT File', single: true }, showMain: false, fullCol: false },

        ]
    },



    trequests: {
        key: "trequests",
        title: 'Trading Requests',
        fetchUrl: 'getAllTRequests',
        addUrl: 'postTRequest',
        editUrl: 'postTRequest',
        removeUrl: 'removeTRequest',
        pageType: 'form',
        // page: 'trequests',
        options: { noAddNew: true },
        addNew: -1,
        parent: 'main',
        image: '/images/covers/1.jpg',
        tabs: [
            { title: 'Pending', filter: { "status": '0' } },
            { title: 'In Progress', filter: { "status": '1' } },
            { title: 'Finished', filter: { "status": '2' } },
            // { title: 'Canceled', filter: { "status": '-1' } },
        ],

        headers: [
            { key: 'trequestId', type: 'TextInput', information: { label: 'Request Id', disabled: true, }, showMain: true, settings: { disabled: true }, fullCol: true, inExport: true },

            { type: 'TextInput', key: 'name', col: '6', information: { label: 'Name', }, showMain: true },
            { type: 'TextInput', key: 'phone', col: '6', information: { label: 'Phone', }, showMain: true },
            { type: 'TextAreaInput', key: 'description', information: { label: 'Description', }, showMain: true },
            { type: 'TextAreaInput', key: 'remark', information: { label: 'Remark', }, showMain: true },
            { key: 'status', type: 'SelectInput', col: '6', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "Pending", value: '0' }, { title: 'In Progress', value: '1' }, { title: 'Finished', value: '2' }, { title: "Canceled", value: '-1' }, ] }, settings: { required: true }, showMain: true, inExport: true },

            { key: 'equipment', type: 'SelectInput', col: '6', information: { label: 'Equipment', type: 'api', fields: { value: '_id', title: 'tequipmentId' }, address: 'getAllTEquipments', filter: {}, linkInfo: { ref: "tequipments", loader: "isPostingData", } }, showMain: false },
            { key: 'creator', type: 'SelectInput', col: '6', information: { label: 'Requester', type: 'api', fields: { value: '_id', title: 'values.company' }, address: 'getUsers', filter: {} }, settings: { required: true, url: '/users/getOneFilter', page: 'users', showInfo: true, disabled: true }, showMain: false, inExport: true },

            // { type: 'SelectInput', key: 'values.country', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'countries' } }, settings: { required: true }, showMain: false },

        ],
    },






    tcategories: {
        key: 'tcategories',
        title: 'Trading Equipment Category',
        description: 'Trading Categories List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'tcategories',
        parent: 'main',
        image: '/images/covers/4.jpg',
        extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        // populate: ["parent"],

        headers: [
            { type: 'TextInput', key: 'values.name', col: '6', information: { label: 'Name', }, showMain: true, inExport: true },
            { type: 'TextInput', key: 'values.slug', col: '6', information: { label: 'Slug', }, showMain: true, inExport: true },
            { key: 'values.image', type: 'ImageInput', col: '12', information: { label: 'Image', single: true, cropper: true }, showMain: true, fullCol: true },

            { type: 'NumberInput', key: 'values.priority', col: '6', information: { label: 'Priority', }, showMain: false },

            //////// hideInList
            { type: 'NumberInput', key: 'values.count', col: '6', information: { label: 'Count', }, showMain: true, hideInList: true, inExport: true },
            { type: 'SelectInput', key: 'values.parent', col: '6', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tcategories' } }, settings: { required: false }, showMain: false, fullCol: true },

            { key: 'values.description', type: 'TextInput', col: '12', information: { label: 'Description', }, showMain: false, inExport: true },
            // { type: 'SwitchInput', key: 'values.withOperator', showMain: true, col: '6', information: { label: 'with operator', inExport: true } },
            // { type: 'SwitchInput', key: 'values.withoutInsurance', showMain: true, col: '6', information: { label: 'Without Insurance', inExport: true }, showMain: false },

            { type: 'EditorInput', key: 'values.body', information: { label: 'Body', }, showMain: false, fullCol: true },

            { key: 'values.deactive', type: 'SwitchInput', col: '6', information: { label: 'Deactive', }, showMain: true, },
            { key: 'values.multiple', type: 'SwitchInput', col: '6', information: { label: 'Multiple Available', }, showMain: true, },

            // { key: 'values.isSearchable', type: 'SwitchInput', col: '6', information: { label: 'Is searchable', }, showMain: true, },
            // { title: 'Edit', type: 'button', function: 'edit', options: { color: "#78b2d0" }, showMain: true }, { title: 'Remove', type: 'button', function: 'remove', options: { color: "#dd8aa4" }, showMain: true }
        ],
    },



    tattributes: {
        key: 'tattributes',
        title: 'Trading Equipment Specification',
        description: 'Trading Equipment Specification List',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'tattributes',
        parent: 'extra',
        image: '/images/covers/6.jpg',
        // populate: ["categories"],

        headers: [
            { type: 'TextInput', key: 'values.name', information: { label: 'Name', }, showMain: true },
            { type: 'MultiSelectInput', key: 'values.categories', information: { label: 'Categories', tag: false, type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tcategories' } }, settings: { required: true }, showMain: false },
            // { type: 'NumberInput', key: 'values.min', col: '6', information: { label: 'Min', }, showMain: true },
            // { type: 'NumberInput', key: 'values.max', col: '6', information: { label: 'Max', }, showMain: true },
            // { type: 'NumberInput', key: 'values.steps', col: '6', information: { label: 'Steps', }, showMain: false },
            { type: 'NumberInput', key: 'values.min', col: '6', information: { label: 'Min', }, showMain: true },
            { type: 'NumberInput', key: 'values.max', col: '6', information: { label: 'Max', }, showMain: true },
            { type: 'NumberInput', key: 'values.steps', col: '6', information: { label: 'Steps', }, showMain: false },

            { type: 'TextInput', key: 'values.suffix', col: '6', information: { label: 'Suffix', }, showMain: true },
            // { type: 'SwitchInput', key: 'values.isEditableInWiki', col: '6', information: { label: 'Is Editable In Wiki', }, showMain: false },


        ],
    },






    tplaces: {
        key: "tplaces",
        title: 'Trading Places',
        fetchUrl: 'getAll',
        addUrl: 'addValue',
        editUrl: 'addValue',
        removeUrl: 'removeValue',
        pageType: 'form',
        page: 'tplaces',
        parent: 'extra',
        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', key: 'values.name', col: '6', information: { label: 'Name', }, showMain: true },
            { type: 'SelectInput', key: 'values.parent', col: '6', information: { label: 'Parent', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'tplaces' } }, settings: { required: false }, showMain: false, fullCol: true },

            // { type: 'SelectInput', key: 'values.country', information: { label: 'Country', type: 'api', fields: { value: '_id', title: 'values.name' }, address: 'getAll', filter: { page: 'countries' } }, settings: { required: true }, showMain: false },

        ],
    },




    // tlogs: {
    //     key: "tlogs",
    //     title: 'Trading Logs',
    //     description: 'Trading Logs List',
    //     fetchUrl: 'getInbox',
    //     // addUrl: 'addEmployee',
    //     // editUrl: 'addEmployee',
    //     // removeUrl: 'removeEmployee',
    //     pageType: 'form',
    //     page: 'logs',
    //     parent: 'admin',
    //     addNew: -1,
    //     options: { noAddNew: true },
    //     actions: {},
    //     tabs: [
    //         { title: 'Admins', filter: { "role": 'admin' } },
    //         { title: 'Users', filter: { "role": 'user' } },

    //     ],

    //     image: '/images/covers/1.jpg',
    //     headers: [
    //         { type: 'TextInput', key: 'message', information: { label: 'Message', }, showMain: true },
    //         { type: 'DateInput', key: 'cDate', information: { label: 'Date/Time', time: true }, showMain: true },

    //         { type: 'TextInput', key: 'type', information: { label: 'Type', }, showMain: true },

    //     ],
    // },





}


export { tradingPages, tradingSections }
